import * as types from "./pbs.types";

const initialState = {
	form_values: null,
};

// biome-ignore lint/style/useDefaultParameterLast: It's required by Redux to ask for the state first.
export default function pbs_reducer(state = initialState, action) {
	switch (action.type) {
		// SET FORM VALUES
		case types.PBS_FORM_VALUES_SET:
		case types.PBS_SYNC_FORM_VALUES_SET:
			return {
				...state,
				form_values: action.payload,
			};

		// RESET FORM VALUES
		case types.PBS_FORM_VALUES_RESET:
		case types.PBS_SYNC_FORM_VALUES_RESET:
			return initialState;

		default:
			return state;
	}
}
